<template>
    <component :is="myActionTriggerComponentData.template"
       @action-triggered="handleActionTrigger"
       :template="myActionTriggerComponentData.template"
       :label="myActionTriggerComponentData.label"
       :display="myActionTriggerComponentData.display"
    >
    </component>
</template>

<script>
    import PreviewComponent from "./PreviewComponent";
    import ActionTriggerComponent from "../../components/pagesbuilder/dynamic-components/ActionTriggerComponent";
    import SeeAll from "../../author/pagesbuilder/templates/cards/SeeAll";
    import LoadMore from "../../author/pagesbuilder/templates/cards/LoadMore";
    import SliderForthArrow from "../../author/pagesbuilder/templates/cards/SliderForthArrow";
    import SliderBackArrow from "../../author/pagesbuilder/templates/cards/SliderBackArrow";
    export default {
        name: "ActionTriggerComponent",
        mixins: [
            PreviewComponent,
            ActionTriggerComponent
        ],
        components: {
            SeeAll,
            LoadMore,
            SliderBackArrow,
            SliderForthArrow
        },
    }
</script>

